<template>
  <div class="portfolio">
    <div class="slide-box" v-if="serviceDetail">
      <div class="slide-photo">
        <div class="button-box">
          <div class="prev-button" @click.stop="prev">
            <button class="prev" @click.stop="prev"></button>
          </div>
          <div class="next-button" @click.stop="next">
            <button class="next" @click.stop="next"></button>
          </div>
        </div>

        <img
          v-for="(item, index) in serviceDetail.portfolio"
          v-imageLoading="item.mainFullPath"
          :class="{ active: targetKey == index }"
          :key="index"
          transition="fade"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixCommon from '../../mixin/common'

export default {
  mixins: [mixCommon],
  name: 'portfolio',
  data() {
    return {
      targetKey: 0
    }
  },
  methods: {
    next() {
      let count = this.targetKey + 1
      if (count < this.serviceDetail.portfolio.length) {
        this.targetKey = count
      } else {
        this.targetKey = 0
      }
    },
    prev() {
      let count = this.targetKey - 1
      if (count >= 0) {
        this.targetKey = count
      } else {
        this.targetKey = this.serviceDetail.portfolio.length - 1
      }
    }
  },
  computed: {
    ...mapGetters(['serviceDetail'])
  }
}
</script>

<style lang="scss" scoped>
.portfolio {
  /*border: 1px dashed red;*/
  width: 95%;
  height: 95%;
  position: relative;
  .slide-box {
    button {
      border: 0;
      outline: none;
      cursor: pointer;
      opacity: 0.4;
      background-color: #fff;
      position: absolute;
      z-index: 10;
    }
    .slide-photo {
      /*border: 1px solid red;*/
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      .button-box {
        display: flex;
        /*border: 1px solid red;*/
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 10;
        opacity: 1;

        .prev-button {
          cursor: pointer;
          width: 50%;
          height: inherit;
          background-color: transparent;
          .prev {
            margin: auto 0;
            top: 0;
            bottom: 0;
            left: 0;
            width: 80px;
            height: 80px;
            &:before {
              border-top: 2px solid #0f00ff;
              border-left: 2px solid #0f00ff;
              content: '';
              margin: auto;
              top: 0;
              bottom: 0;
              right: 0;
              left: -38px;
              width: 15px;
              height: 15px;
              position: absolute;
              transform: rotate(-50deg);
              transition: all 0.3s ease-in-out;
            }

            &:after {
              border-top: 2px solid #0f00ff;
              content: '';
              margin: auto;
              width: 60px;
              height: 20px;
              top: 22px;
              bottom: 0;
              right: 0;
              left: 2px;
              position: absolute;
              transition: all 0.3s ease-in-out;
            }
          }
          &:hover {
            .prev {
              &:before {
                left: -50px;
              }

              &:after {
                left: -50px;
                width: 20px;
              }
            }
          }
        }

        .next-button {
          cursor: pointer;
          /*border: 1px solid red;*/
          width: 50%;
          height: inherit;
          background-color: transparent;
          .next {
            margin: auto 0;
            top: 0;
            bottom: 0;
            right: 0;
            z-index: 10;
            width: 80px;
            height: 80px;
            &:before {
              border-right: 2px solid #0f00ff;
              border-bottom: 2px solid #0f00ff;
              content: '';
              margin: auto;
              top: 0;
              bottom: 0;
              right: 0;
              left: 38px;
              width: 15px;
              height: 15px;
              position: absolute;
              transform: rotate(-50deg);
              transition: all 0.3s ease-in-out;
            }

            &:after {
              border-top: 2px solid #0f00ff;
              content: '';
              margin: auto;
              width: 60px;
              height: 20px;
              top: 20px;
              bottom: 0;
              right: 0;
              left: -1px;
              position: absolute;
              transition: all 0.3s ease-in-out;
            }
          }
          &:hover {
            .next {
              &:before {
                left: 50px;
              }

              &:after {
                left: 50px;
                width: 20px;
              }
            }
          }
        }
      }

      /*border: 1px solid red;*/
      width: 100%;
      min-height: 600px;
      img {
        margin: auto;
        top: 0;
        bottom: 0;
        left: -100px;
        right: 0;
        position: absolute;
        max-width: 100%;
        max-height: 800px;
        transition: all 0.3s ease-in-out;
        visibility: hidden;
        opacity: 0;
        object-fit: cover;
        &.active {
          visibility: visible;
          opacity: 1;
          left: 0;
        }
      }
    }
  }
}

.fade-transition {
  transition: all 0.8s ease;
  overflow: hidden;
  visibility: visible;
  opacity: 1;
  position: absolute;
}

.fade-enter,
.fade-leave {
  opacity: 0;
  visibility: hidden;
}
</style>
